<template>
  <div class="phone-display">
    <div class="row">
      <label class="col-sm-4 col-form-label">{{ field.label }}</label>
      <div class="col-sm-8"><a :href="`tel:${field.value}`">{{ field.value }}</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneDisplay',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/PhoneDisplay.vue